module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": function($event) {
        return _vm.reloadVideo()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ca2e4d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VLink.vue
// module id = 115
// module chunks = 0